import { render, staticRenderFns } from "./SaleSearch.vue?vue&type=template&id=8d1bf8f2&scoped=true"
import script from "./SaleSearch.vue?vue&type=script&lang=js"
export * from "./SaleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1bf8f2",
  null
  
)

export default component.exports